// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"9334d1ae","117":"c1c5f594","683":"30b39fea","711":"f8550630","841":"189a0b46","954":"5f6644a3"}[chunkId] + ".chunk.css";
};